import config from '../constants/config';
import { getToken } from './session';
import {
    TOKEN_EXPIRED, UNEXPECTED_ERROR, NO_RECORD_FOUND,
    VALIDATIONS_ERROR, UNAUTHORISEDUSER, RECORD_FOUND
} from '../constants/messages';
const axios = require('axios');

export class WebAgent {
    token = null;
    constructor(baseURL) {
        this.requests = {};

        this.createInstance = this.createInstance.bind(this);
        this.setConfig = this.setConfig.bind(this);
        this.setToken = this.setToken.bind(this);
        this.cancel = this.cancel.bind(this);
        this.createInstance(baseURL);
    }

    createInstance(baseURL) {
        this.instance = baseURL ? axios.create({ baseURL }) : axios.create();
        this.instance.defaults.timeout = 1 * 60 * 1000; // Now all requests will wait 1 minute before timing out
        this.instance.defaults.headers['content-type'] = 'application/json';
        this.instance.defaults.responseType = 'json';
        this._attachRequestManager();
    }

    setToken(_token) {
        if (_token) this.token = _token;
        return this;
    }

    setConfig(userConfig) {
        const config = { ...userConfig };
        const isAuthenticate = config.hasOwnProperty("isAuthenticate") ? config.isAuthenticate : true;
        const token = config.hasOwnProperty("token") ? config.token : this.token;
        if (isAuthenticate && token) {
            if (!config.hasOwnProperty('headers')) config.headers = {};
            config.headers['x-access-token'] = token;
        }
        return config;
    }

    get(url, data, _config = {}) {
        const config = { params: (data || {}), ...this.setConfig(_config) };
        return this.instance.get(url, config);
    }

    post(url, data, config = {}) {
        return this.instance.post(url, data, this.setConfig(config));
    }

    put(url, data, config = {}) {
        return this.instance.put(url, data, this.setConfig(config));
    }

    delete(url, data, _config = {}) {
        const config = { params: (data || {}), ...this.setConfig(_config) };
        return this.instance.delete(url, config);
    }

    cancel(requestId, reason) {
        if (requestId && this.requests[requestId]) {
            this.requests[requestId](reason || "Previous request cancelled");
            delete this.requests[requestId];
        }
    }

    isCancel(thrown) {
        return axios.isCancel(thrown);
    }

    _attachRequestManager() {
        const me = this;

        this.instance.interceptors.request.use(config => {
            const { requestId } = config;
            if (requestId) {
                const source = axios.CancelToken.source();
                config.cancelToken = source.token;

                if (me.requests[requestId]) me.cancel(requestId);
                me.requests[requestId] = source.cancel;
            }
            return config;
        });

        this.instance.interceptors.response.use(response => {
            const config = response.config;
            const { requestId } = config;
            if (requestId) me.cancel(requestId);
            return response;
        });
    }
}

export const createWebAgent = (baseURL) => {
    return new WebAgent(baseURL);
}

export const apiResponse = (res, whenEmpty = null) => {
    const apiResult = {
        code: null, message: null, data: null,
        status: null, isUnauthorized: false
    };

    if (res && typeof res === 'object') {
        let response = res.data;
        apiResult.status = response.status;
        apiResult.code = response.code;
        apiResult.isUnauthorized = ([TOKEN_EXPIRED.code, UNAUTHORISEDUSER.code].indexOf(response.code) >= 0);

        if (apiResult.isUnauthorized) {
            apiResult.data = null;
            apiResult.message = response.message;
        } else if (response.code === RECORD_FOUND.code) {
            apiResult.data = response.data;
            apiResult.message = null;
        } else if (response.code === NO_RECORD_FOUND.code) {
            apiResult.data = whenEmpty ? whenEmpty : response.data;
            apiResult.message = null;
        } else if (response.code === ([UNEXPECTED_ERROR.code, VALIDATIONS_ERROR.code].indexOf(response.code) >= 0) ||
            (response.status && response.status.toLowerCase() === 'error')) {
            apiResult.data = null;
            apiResult.message = response.message;
        } else {
            apiResult.data = response.data;
            apiResult.message = response.message;
        }
    }
    return apiResult;
}

export const defaultAgent = new WebAgent(config.common.APP_API_URL).setToken(getToken());


export const uploadToGoogle = ({ attachment, uploadUrl }, cb) => {

    const params = {
        method: 'POST',
        headers: { 'content-type': attachment.file.type, 'Content-Range': 'bytes 0-500/500' },
        data: attachment.file,
        onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            const uploadPercent = Math.round((loaded * 100) / total);
            if (cb) cb({ uploadPercent, total });
        }
    };

    const fileName = attachment.name;
    return axios(`${uploadUrl}${fileName}`, params);
}